var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SliderWidget',_vm._b({attrs:{"value-pair":_vm.value,"invert-process":_vm.invertProcess},on:{"updateWidget":_vm.onChange}},'SliderWidget',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }